import React, { useState, useEffect } from "react";
import axios from "axios";

export default function SearchWidget() {
    const [searchTerm, setSearchTerm] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalSearch, setModalSearch] = useState("");
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const performSearch = () => {
        if (searchTerm.trim().length > 0) {
            setModalSearch(searchTerm);
            setModalOpen(true);
        }
    };

    const handleSearchClick = () => {
        performSearch();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            performSearch();
        }
    };

    const handleModalSearch = async (searchValue) => {
        setModalSearch(searchValue);
        if (searchValue.trim() === "") {
            setFilteredPosts([]);
            return;
        }

        try {
            setLoading(true);
            const url = `${process.env.REACT_APP_WP_API_URL_V2}/posts`;
            const response = await axios.get(
                url,
                {
                    params:{
                        status: "publish",
                        search: searchValue
                    }
                }
            );
            setFilteredPosts(response.data);
        } catch (err) {
            setError("Erreur lors de la recherche des articles.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (modalSearch.trim() !== "") {
            handleModalSearch(modalSearch);
        }
    }, [modalSearch]);

    const decodeHTML = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };

    return (
            <div className="search-box">
                <div className="form-group" style={{ position: "relative" }}>
                    <input className="blog-search"
                           type="text"
                           placeholder="Mots-clés, articles, Formations ..."
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                           onKeyDown={handleKeyDown}

                    />
                    <div className="search-icon icon-Loupe"
                         onClick={handleSearchClick}
                         style={{
                             position: "absolute",
                             right: "5px",
                             top: "50%",
                             transform: "translateY(-50%)",
                             cursor: "pointer",
                         }}>
                    </div>
                </div>

                {modalOpen && (
                        <div className="custom-modal">
                            <div className="custom-modal-content">
                                <div className="custom-modal-header">
                                    <span className="custom-modal-close"
                                          onClick={() => setModalOpen(false)}></span>
                                </div>
                                <div className="custom-modal-body">
                                <div className="d-flex justify-content-between">
                                        <input
                                                type="text"
                                                placeholder="Rechercher parmi les articles..."
                                                value={modalSearch}
                                                onChange={(e) =>
                                                        handleModalSearch(e.target.value)
                                                }
                                                className="modal-search-input"
                                        />
                                        <span className="icon-Loupe"
                                              style={{
                                                  fontWeight: "800",
                                                  fontSize: "26px",
                                                  color:"#c8c8c8",
                                                  height: "100%",
                                                  marginLeft: 5
                                        }}/>
                                    </div>

                                    {/* Résultats filtrés */}
                                    {loading ? (
                                            <p>Chargement des articles...</p>
                                    ) : error ? (
                                            <p>{error}</p>
                                    ) : (
                                            <ul className="modal-results">
                                                {filteredPosts.length > 0 ? (
                                                        filteredPosts.map((post) => (
                                                                <li key={post.id}>
                                                                    <h5><a href={`/blog/${post.slug}`}>{decodeHTML(post.title.rendered)}</a>                                                                    </h5>
                                                                    <p
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: post.excerpt
                                                                                        ?.rendered,
                                                                            }}
                                                                    ></p>
                                                                </li>
                                                        ))
                                                ) : (
                                                        <p>Aucun résultat trouvé.</p>
                                                )}
                                            </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                )}
            </div>
    );
}
